import { Component, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';
import { SecurityService } from '~/services/security.service';

@Component({
    selector: 'app-component-base',
    template: '',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ComponentBase implements OnDestroy {
  private _disposables: Function[];
  private _subscriptions: Subscription[];

  constructor() { }

  ngOnDestroy() {
    if (this._disposables) {
      for (const disposable of this._disposables) {
        disposable();
      }
    }

    if (this._subscriptions) {
      for (const subscription of this._subscriptions) {
        subscription.unsubscribe();
      }
    }
  }

  protected registerDisposable(disposable: Function) {
    if (!this._disposables) {
      this._disposables = [];
    }

    this._disposables.push(disposable);
  }

  protected registerSubscription(subscription: Subscription) {
    if (!this._subscriptions) {
      this._subscriptions = [];
    }

    this._subscriptions.push(subscription);
  }
}
